import { styled } from "@mui/material/styles";

export const Wrapper = styled("header")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  "@media (min-width: 360px)": {
    justifyContent: "flex-start",
  }
}));

export const LogoWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  width: "13.5rem",
  marginBottom: "2.5rem",
  "& > img": {
    objectFit: "contain",
  },
  "@media (min-width: 360px)": {
    justifyContent: "flex-start",
  },
}))

export const HeaderInfoWrapper = styled("div")(() => ({
  border: "1px solid #eae7ec",
  borderRadius: 6,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  backgroundColor: "#fff",
}))

export const HeaderInfoTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "1.466rem",
  lineHeight: "28px",
  color: "#0055a4",
  marginBottom: "12px",
}))

export const LabelContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
}));

export const LabelWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: 8,
  "&:first-of-type": {
    marginTop: "0.75rem",
  }
}))

export const Label = styled("span")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "0.933rem",
  letterSpacing: 0.1,
  lineHeight: "20px",
}))

export const Value = styled("span")(() => ({
  color: "#1D2939",
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "0.933rem",
  letterSpacing: 0.1,
  lineHeight: "20px",
}))

